import { render, staticRenderFns } from "./ModalJobDescription.vue?vue&type=template&id=6c454919&scoped=true&"
import script from "./ModalJobDescription.vue?vue&type=script&lang=js&"
export * from "./ModalJobDescription.vue?vue&type=script&lang=js&"
import style0 from "./ModalJobDescription.vue?vue&type=style&index=0&id=6c454919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c454919",
  null
  
)

export default component.exports